import { defineStore } from 'pinia'
import api from '../services/api'

export const useUnitsStore = defineStore('units', {
  state: () => ({
    units: [],
    loading: false,
    error: null,
    fetched: false
  }),

  getters: {
    unitsByCode: (state) => {
      const map = {}
      state.units.forEach(u => { map[u.code] = u })
      return map
    },

    unitsByName: (state) => {
      const map = {}
      state.units.forEach(u => { map[u.name] = u })
      return map
    },

    weightUnits: (state) => {
      return state.units.filter(u => u.category === 'weight')
    },

    volumeUnits: (state) => {
      return state.units.filter(u => u.category === 'volume')
    },

    countUnits: (state) => {
      return state.units.filter(u => u.category === 'count')
    },

    weightUnitNames: (state) => {
      return state.units.filter(u => u.category === 'weight').map(u => u.name)
    },

    volumeUnitNames: (state) => {
      return state.units.filter(u => u.category === 'volume').map(u => u.name)
    },

    baseVolumeUnitNames: (state) => {
      return state.units
        .filter(u => u.category === 'volume')
        .map(u => u.name.toLowerCase())
    },

    allUnitNames: (state) => {
      return state.units.map(u => u.name)
    }
  },

  actions: {
    async fetchUnits() {
      if (this.fetched) return
      this.loading = true
      this.error = null
      try {
        const response = await api.units.getAll()
        const data = response.data
        // Normalize conversionFactor to number
        this.units = (Array.isArray(data) ? data : data?.data || []).map(u => ({
          ...u,
          conversionFactor: parseFloat(u.conversionFactor)
        }))
        this.fetched = true
      } catch (error) {
        this.error = error.message
        console.error('Error fetching units:', error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Resolve a unit identifier to a unit object.
     * Handles codes (LB), names (Pounds), and case-insensitive fallback.
     */
    resolveUnit(identifier) {
      if (!identifier) return null
      // Try exact code match
      const byCode = this.unitsByCode[identifier]
      if (byCode) return byCode
      // Try exact name match
      const byName = this.unitsByName[identifier]
      if (byName) return byName
      // Case-insensitive fallback
      const lower = identifier.toLowerCase()
      return this.units.find(
        u => u.code.toLowerCase() === lower || u.name.toLowerCase() === lower
      ) || null
    }
  }
})
